import { useCallback, useEffect, useState } from "react";
import { ChevronDown, Layers, Loader2, Plus } from "lucide-react";
import { socialApi } from "@/api/social";
import PostCard from "@/components/social/PostCard";

const PAGE = 10;

export default function ProfileFeed({ refreshKey, open = true, onToggleOpen }) {
  const [items, setItems] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (off) => {
    setLoading(true);
    try {
      const r = await socialApi.myFeed(off, PAGE);
      setItems((prev) => (off === 0 ? r.items : [...prev, ...r.items]));
      setOffset(off + (r.items?.length || 0));
      setHasMore(r.has_more);
      setTotal(r.total);
    } catch { /* ignore */ } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(0); }, [load, refreshKey]);

  return (
    <section className="mt-4" data-testid="profile-feed">
      <button onClick={() => onToggleOpen?.()} data-testid="whats-up-accordion-toggle"
        className="w-full flex items-center gap-2 bg-charcoal text-white border-2 border-charcoal rounded-2xl px-4 py-3 shadow-[4px_4px_0px_#D4AF37]">
        <Layers size={16} className="text-gold" />
        <span className="font-mono text-[11px] font-black uppercase tracking-[0.22em] flex-1 text-left">What's Up</span>
        <span className="font-mono text-[10px] text-white/60">{total}</span>
        <ChevronDown size={18} className={`text-gold transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="mt-3 space-y-3" data-testid="profile-feed-list">
          {items.length === 0 && !loading && (
            <div className="border-2 border-dashed border-charcoal/25 rounded-2xl py-8 text-center" data-testid="feed-empty">
              <Plus size={22} className="mx-auto text-charcoal/30" />
              <p className="mt-2 font-mono text-[11px] text-charcoal/50 uppercase tracking-widest">No posts or reels yet</p>
            </div>
          )}
          {items.map((it) => (
            <PostCard key={`${it.type}-${it.id}`} post={it} onChanged={() => load(0)} />
          ))}
          {loading && <div className="flex justify-center py-3"><Loader2 size={20} className="text-gold animate-spin" /></div>}
          {hasMore && !loading && (
            <button onClick={() => load(offset)} data-testid="feed-see-more-btn"
              className="w-full bg-gold text-black font-black font-mono text-[11px] uppercase tracking-widest py-3 rounded-2xl border-2 border-charcoal shadow-[4px_4px_0px_#1A1A1A] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-[transform,box-shadow] duration-150">
              See More
            </button>
          )}
        </div>
      )}
    </section>
  );
}
